import dao from '../../common/DataAccessUtil';
import UtilityService from '../../common/UtilityService';
import { enumPermissions } from '../../enums';
import configurationService from '../core/configuration.service';
import { IPermissionItem } from './permission.service.js';
const ControllerName = 'users';
export interface IUserItem {
  Id: string;
  Name: string;
  Family: string;
  Mobile: string;
  NationalCode: string;
  Email: string;
  UserName: string;
  Active: boolean;
  IsDomainUser: boolean;
}
export default {
  otplogin: async (
    phoneNumber: string,
    captchaText: string,
    dntCaptchaTextValue: string,
    dntCaptchaTokenValue: string,
  ) => {
    const body = {
      PhoneNumber: phoneNumber,
      DNTCaptchaText: dntCaptchaTextValue,
      DNTCaptchaToken: dntCaptchaTokenValue,
      DNTCaptchaInputText: captchaText,
    };
    return dao.PostFormData(configurationService.getApiConfigForIdentityServer(), ControllerName + '/otplogin', body);
  },
  sendOtp: async (
    phoneNumber: string,
    captchaText: string,
    dntCaptchaTextValue: string,
    dntCaptchaTokenValue: string,
  ) => {
    const body = {
      PhoneNumber: phoneNumber,
      DNTCaptchaText: dntCaptchaTextValue,
      DNTCaptchaToken: dntCaptchaTokenValue,
      DNTCaptchaInputText: captchaText,
    };
    return dao.PostFormData(configurationService.getApiConfigForIdentityServer(), ControllerName + '/sendOtp', body);
  },
  verifyotplogin: async (phoneNumber: string, code: string) => {
    const body = { PhoneNumber: phoneNumber, VerifyCode: code };
    return dao.postJsonData(
      configurationService.getApiConfigForIdentityServer(),
      ControllerName + '/verifyotplogin',
      body,
    );
  },
  verifyMyGovCode: async (code: string) => {
    const body = { VerifyCode: code };
    return dao.postJsonData(
      configurationService.getApiConfigForIdentityServer(),
      ControllerName + '/verifyMyGovCode',
      body,
    );
  },
  verifyRegister: async (phoneNumber: string, nationalId, code: string) => {
    const body = { PhoneNumber: phoneNumber, NationalId: nationalId, VerifyCode: code };
    return dao.postJsonData(configurationService.getApiConfigForIdentityServer(), ControllerName + '/verify', body);
  },
  updatePhoneNumber: async (phoneNumber: string, code: string) => {
    const body = { PhoneNumber: phoneNumber, VerifyCode: code };
    return dao.postJsonData(configurationService.getApiConfigForIdentityServer(), ControllerName + '/editphone', body);
  },
  updateUserPass_client: async (
    oldPassword: string,
    newPassword: string,
    captchaText: string,
    dntCaptchaTextValue: string,
    dntCaptchaTokenValue: string,
  ) => {
    const body = {
      CurrentPassword: oldPassword,
      NewPassword: newPassword,
      ConfirmPassword: newPassword,
      DNTCaptchaText: dntCaptchaTextValue,
      DNTCaptchaToken: dntCaptchaTokenValue,
      DNTCaptchaInputText: captchaText,
    };
    return dao.PostFormData(
      configurationService.getApiConfigForIdentityServer(),
      ControllerName + '/changePassword',
      body,
    );
  },
  updateUserProfile: async (
    firstName: string,
    lastName: string,
    employeeNumber: string,
    email: string,
    job: string,
    major: string,
    grade: string,
    gender: number,
    phoneNumber: string,
    provinceId: number,
    cityId: number,
    captchaText: string,
    dntCaptchaTextValue: string,
    dntCaptchaTokenValue: string,
  ) => {
    const body = {
      FirstName: firstName,
      LastName: lastName,
      NationalId: employeeNumber,
      Email: email,
      Job: job,
      Major: major,
      Grade: grade,
      Gender: gender,
      PhoneNumber: phoneNumber,
      ProvinceId: provinceId,
      CityId: cityId,
      DNTCaptchaText: dntCaptchaTextValue,
      DNTCaptchaToken: dntCaptchaTokenValue,
      DNTCaptchaInputText: captchaText,
    };
    return dao.PostFormData(
      configurationService.getApiConfigForIdentityServer(),
      ControllerName + '/editprofile',
      body,
    );
  },
  setPassword: async (
    password: string,
    captchaText: string,
    dntCaptchaTextValue: string,
    dntCaptchaTokenValue: string,
  ) => {
    const body = {
      Password: password,
      DNTCaptchaText: dntCaptchaTextValue,
      DNTCaptchaToken: dntCaptchaTokenValue,
      DNTCaptchaInputText: captchaText,
    };
    return dao.PostFormData(
      configurationService.getApiConfigForIdentityServer(),
      ControllerName + '/setPassword',
      body,
    );
  },
  getUserRoles: async (itemGuid: string) => {
    return dao.getJsonData(configurationService.getApiConfigForIdentityServer(), ControllerName + '/roles/' + itemGuid);
  },
  HasPassword: async () => {
    return dao.getJsonData(configurationService.getApiConfigForIdentityServer(), ControllerName + '/haspassword');
  },
  hasRoles: async (roleGUID: string) => {
    return dao.getJsonData(
      configurationService.getApiConfigForIdentityServer(),
      ControllerName + '/hasRoles/' + roleGUID,
    );
  },

  getAll: async (filterTxt: string, pageNumber: number, pageSize: number) => {
    let filter = '';
    if (!UtilityService.isNullOrEmpty(filterTxt)) filter = '/' + filterTxt;
    return dao.getJsonData(
      configurationService.getApiConfigForIdentityServer(),
      ControllerName + '/users/' + pageNumber + '/' + pageSize + '/Id asc' + filter,
    );
  },
  getById: async (itemId: number) => {
    return dao.getJsonData(configurationService.getApiConfigForIdentityServer(), ControllerName + '/' + itemId);
  },
  getCurrentUserProfile: async () => {
    return dao.getJsonData(configurationService.getApiConfigForIdentityServer(), ControllerName);
  },
  HasPermission_client: async (permissionByKey: enumPermissions) => {
    try {
      const response = await dao.getJsonData(
        configurationService.getApiConfigForIdentityServer(),
        ControllerName + '/permissions',
      );
      return (response as IPermissionItem[]).findIndex((x) => (x.Id = permissionByKey)) > -1;
    } catch (ex) {
      const err = ex as any;
      if (err.response) {
        if (err.response.status === 403) {
          return false;
        }
      }
      return false;
    }
  },
  GetPermissions_client: async (): Promise<IPermissionItem[]> => {
    try {
      const response = await dao.getJsonData(
        configurationService.getApiConfigForIdentityServer(),
        ControllerName + '/permissions',
      );

      return response;
    } catch (ex) {
      const err = ex as any;
      if (err.response) {
        if (err.response.status === 403) {
          return [];
        }
      }
      return [];
    }
  },
  create: async (
    firstName: string,
    lastName: string,
    phoneNumber: string,
    codemeli: string,
    email: string,
    username: string,
    pass: string,
    isDomainUser: boolean,
  ) => {
    const body = {
      FirstName: firstName,
      LastName: lastName,
      PhoneNumber: phoneNumber,
      EmployeeNumber: codemeli,
      Email: email,
      UserName: username,
      Password: pass,
      LoginProvider: isDomainUser ? 0 : 1,
    };

    return dao.postJsonData(configurationService.getApiConfigForIdentityServer(), ControllerName, body);
  },
  update: async (
    itemGuid: string,
    firstName: string,
    lastName: string,
    phoneNumber: string,
    codemeli: string,
    username: string,
    email: string,
  ) => {
    const body = {
      Id: itemGuid,
      FirstName: firstName,
      LastName: lastName,
      PhoneNumber: phoneNumber,
      EmployeeNumber: codemeli,
      UserName: username,
      Email: email,
    };
    return dao.update(configurationService.getApiConfigForIdentityServer(), ControllerName, '', body);
  },

  updateUserRole: async (itemGuid: string, RoleGUID: string[]) => {
    const body = { UserId: itemGuid, Roles: RoleGUID };
    return dao.postJsonData(configurationService.getApiConfigForIdentityServer(), ControllerName + '/assignrole', body);
  },

  delete: async (userGuid: string) => {
    return dao.delete(configurationService.getApiConfigForIdentityServer(), ControllerName, userGuid.toString());
  },

  HasPermission: async (permissionByKey: enumPermissions) => {
    try {
      const response = await dao.getJsonData(
        configurationService.getApiConfigForIdentityServer(),
        ControllerName + '/permissions',
      );
      let perms: string[] = [];
      if (response !== null) response.forEach((x) => perms.push(x.id));
      return perms.includes(permissionByKey);
    } catch (ex) {
      const err = ex as any;
      if (err.response) {
        if (err.response.status === 403) {
          return false;
        }
      }
      return false;
    }
  },
  GetPermissions: async (): Promise<IPermissionItem[]> => {
    try {
      const response = await dao.getJsonData(
        configurationService.getApiConfigForIdentityServer(),
        ControllerName + '/permissions',
      );
      let perms: IPermissionItem[] = [];
      if (response !== null) response.forEach((x) => perms.push({ Id: x.id, Name: x.name }));
      return perms;
    } catch (ex) {
      const err = ex as any;
      if (err.response) {
        if (err.response.status === 403) {
          return [];
        }
      }
      return [];
    }
  },
};
